export default __webpack_public_path__ + "static/media/reinput.2bef11d5.svg";